// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { STEP_NAME, WEIGHT_UNITS, type WeightUnit, utils } from '@seedplanner/shared-utils';

type stepTup = readonly [string, number];
export const getDefaultCrops = (): readonly [
  string, // name
  number, // sowingDensity
  number, // ouncesPerTray
  number, // holdTimeDays
  readonly stepTup[], // steps: [stepName, timeToStartAfterFirstStepStep]
  readonly { size: number; unit: string }[], // sizes
  number, // ID
][] => [
  [
    'Arugula, Astro',
    12,
    5.5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 13],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 6, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    1,
  ],
  [
    'Nasturtium, Empress',
    100,
    6,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 8],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    2,
  ],
  [
    'Dill',
    20,
    4,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    3,
  ],
  [
    'Pea, Tendril',
    300,
    16,
    2,
    [
      [STEP_NAME.SOAK, 0],
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 1],
      [STEP_NAME.UNDER_LIGHTS, 4],
      [STEP_NAME.HARVEST, 14],
    ],
    [
      { size: 4, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    4,
  ],
  [
    'Parsley',
    12,
    3.8,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 10],
      [STEP_NAME.HARVEST, 24],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    5,
  ],
  [
    'Radish, Triton',
    40,
    12,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 6],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 6, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    6,
  ],
  [
    'Fava',
    300,
    16,
    2,
    [
      [STEP_NAME.SOAK, 0],
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 1],
      [STEP_NAME.UNDER_LIGHTS, 4],
      [STEP_NAME.HARVEST, 11],
    ],
    [
      { size: 4, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    7,
  ],
  [
    'Chard, Yellow',
    35,
    4.5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    8,
  ],
  [
    'Fennel',
    20,
    5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 6],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    9,
  ],
  [
    'Cabbage',
    19,
    6.5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 10],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 6, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    10,
  ],
  [
    'Onion',
    35,
    6.5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    11,
  ],
  [
    'Mustard, Scarlet Frills',
    10,
    5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    12,
  ],
  [
    // eslint-disable-next-line quotes
    "Beet, Bull's Blood",
    40,
    3.5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    13,
  ],
  [
    'Basil, Lemon',
    4,
    4,
    0,
    [
      [STEP_NAME.PLANT_AND_HUMIDITY_DOME, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    14,
  ],
  [
    'Kohlrabi',
    16,
    6.5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 10],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 6, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    15,
  ],
  [
    'Shiso, Green',
    12,
    5,
    1,
    [
      [STEP_NAME.PLANT_AND_HUMIDITY_DOME, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    16,
  ],
  [
    'Cantaloupe',
    40,
    5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 4],
      [STEP_NAME.HARVEST, 10],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    17,
  ],
  [
    'Chard, Red',
    40,
    4.5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    18,
  ],
  [
    'Cilantro, Split',
    40,
    4.75,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 7],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    19,
  ],
  [
    'Basil, Genovese',
    4,
    4,
    0,
    [
      [STEP_NAME.PLANT_AND_HUMIDITY_DOME, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 24],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    20,
  ],
  [
    'Basil, Purple',
    4,
    4,
    0,
    [
      [STEP_NAME.PLANT_AND_HUMIDITY_DOME, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 24],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    21,
  ],
  [
    'Radish, Daikon',
    40,
    12,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 6],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 6, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    22,
  ],
  [
    'Kale, Dwarf Siberian',
    22,
    8,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 10],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 6, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    23,
  ],
  [
    'Chervil, Curled',
    20,
    3.8,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    24,
  ],
  [
    'Pea, Basic',
    300,
    16,
    2,
    [
      [STEP_NAME.SOAK, 0],
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 1],
      [STEP_NAME.UNDER_LIGHTS, 4],
      [STEP_NAME.HARVEST, 11],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 4, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    25,
  ],
  [
    'Sunflower, Small',
    120,
    16,
    2,
    [
      [STEP_NAME.SOAK, 0],
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 1],
      [STEP_NAME.UNDER_LIGHTS, 4],
      [STEP_NAME.HARVEST, 9],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 4, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    26,
  ],
  [
    'Chard, Magenta',
    40,
    4,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 5],
      [STEP_NAME.HARVEST, 17],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    27,
  ],
  [
    'Celery',
    4,
    5,
    1,
    [
      [STEP_NAME.PLANT_AND_HUMIDITY_DOME, 0],
      [STEP_NAME.UNDER_LIGHTS, 10],
      [STEP_NAME.HARVEST, 24],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    28,
  ],
  [
    'Radish, Rambo',
    40,
    12,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 8],
    ],
    [
      { size: 3, unit: 'ounces' },
      { size: 6, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    29,
  ],
  [
    'Broccoli',
    22,
    6.5,
    1,
    [
      [STEP_NAME.PLANT_AND_WEIGHTED_GERM, 0],
      [STEP_NAME.UNDER_LIGHTS, 3],
      [STEP_NAME.HARVEST, 10],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 3, unit: 'ounces' },
      { size: 6, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
    30,
  ],
];

export const getDefaultCropsMappedForDialog = (preferredWeightUnit: WeightUnit) => {
  const prefersGrams = preferredWeightUnit === WEIGHT_UNITS.GRAMS;

  return getDefaultCrops().map(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([name, sowingDensity, ouncesPerTray, _holdTimeDays, steps, _sizes, id]) => ({
      id,
      cropName: name,
      sowingDensity: `${sowingDensity}g per tray`,
      yield: prefersGrams
        ? `${utils.round(
            utils.convert({
              quantity: ouncesPerTray,
              inputUnit: WEIGHT_UNITS.OUNCES,
              outputUnit: WEIGHT_UNITS.GRAMS,
            }),
            0,
          )} g`
        : `${ouncesPerTray} oz`,
      growTime: `${
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        steps.find(([stepName]) => stepName === STEP_NAME.HARVEST)![1]
      } days`,
      // yieldPerTray: ouncesPerTray,
      // yieldUnit: 'ounces',
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      // growTimeDays: steps.find(([stepName]) => stepName === STEP_NAME.HARVEST)![1],
    }),
  );
};

export const defaultBlends: readonly [
  string,
  readonly [string, number, number][], // Crop name, percent, defaultCropId
  readonly { readonly size: number; readonly unit: string }[],
][] = [
  // [blend name, [crop name, percent][]], sizes]
  [
    'Brassica Blend',
    [
      ['Broccoli', 33, 30],
      ['Cabbage', 34, 10],
      ['Kohlrabi', 33, 15],
    ],
    [
      { size: 2, unit: 'ounces' },
      { size: 6, unit: 'ounces' },
      { size: 8, unit: 'ounces' },
    ],
  ],
];
